import React from 'react';
import Nav from '../Components/nav';
import Hero from '../Pages/Hero';
import Lang from '../Pages/Lang';
import Projects from './Projects';
import About from './About';
import Contact from './Contact';

const Home = () => {
	return (
		<>
			<Hero />
			<Lang />
			<About />
			<Projects />
			<Contact />
		</>
	);
};

export default Home;
